import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider } from 'styled-components';

import 'rsuite/dist/styles/rsuite-default.css';
import './index.css';

import { AuthProvider } from './features/Auth/AuthContext';
import { DocumentModalProvider } from './features/Documents/DocumentModalProvider';
import { Routing } from './features/Routing/Routing';
import i18n from './i18n/i18n';
import reportWebVitals from './reportWebVitals';
import { GlobalStyle, theme } from './utils/theme.utils';

TagManager.initialize({ gtmId: process.env.REACT_APP_GTM });

if (process.env.REACT_APP_POSTHOG_KEY && process.env.REACT_APP_POSTHOG_HOST) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
  });
}

dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
  weekStart: 1,
});

const AppRoot: React.FC = () => {
  const content = (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <AuthProvider>
          <DocumentModalProvider>
            <Routing />
          </DocumentModalProvider>
        </AuthProvider>
      </ThemeProvider>
    </I18nextProvider>
  );

  if (process.env.REACT_APP_POSTHOG_KEY && process.env.REACT_APP_POSTHOG_HOST) {
    return <PostHogProvider client={posthog}>{content}</PostHogProvider>;
  }

  return content;
};

ReactDOM.render(
  <React.StrictMode>
    <AppRoot />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
